export default __webpack_public_path__ + "static/media/12.80c59828.jpg";